import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { findByLabel, transferReasonDropdown } from "../utils";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";

export const tInColumns = [
  new AGridColDef("itemType", "Item Type", false).setMinWidth(150),

  new AGridColDef("description", "Item Description", false).setMinWidth(250),

  new AGridColDef("grossAmount", "Base Amount", false)
    .setMinWidth(150)
    .columnAlign("right")
    .setValueFormatter(params => formattedPrice(params?.value)),

  new AGridColDef("concessionApplied", "Concession (Value)", false)
    .setMinWidth(180)
    .columnAlign("right")
    .setValueFormatter(params => formattedPrice(params?.value)),

  new AGridColDef("netPayable", "Net Payable", false)
    .setMinWidth(150)
    .columnAlign("right")
    .setValueFormatter(params => formattedPrice(params?.value)),

  new AGridColDef("taxes", "Taxes", false)
    .setMinWidth(100)
    .columnAlign("right")
    .setValueFormatter(params => formattedPrice(params?.value)),

  new AGridColDef("payableAmount", "Payable", false)
    .setMinWidth(100)
    .columnAlign("right")
    .setValueFormatter(params => formattedPrice(params?.value)),

  new AGridColDef("paidAmount", "Paid", false)
    .setMinWidth(100)
    .columnAlign("right")
    .setValueFormatter(params => formattedPrice(params?.value)),
];


export const createTransferApprovalRequest = (transferIn, transferOut,outBuType,inBuType) => {
  return {
    ...transferIn,
    transferOutAppId: transferOut.applicationId,
    psid: transferOut.psid,
    studentName: transferOut.studentName,
    outBusinessUnitId: transferOut.businessArea,
    outCourseId: transferOut.courseId,
    termId: transferOut.term,
    termValue: transferOut.termDispVal,
    inBusinessArea: transferIn.businessArea?.label,
    inBusinessUnitId: transferIn.businessArea?.value,
    inCourseId: parseInt(transferIn.courseId?.value),
    outAcademicGroupValue: transferOut.academicGroupDispValue,
    outAcademicGroupId: transferOut?.academicGroup,
    transferInAppId: transferIn?.applicationId || transferIn?.transferInAppId,
    inAcademicGroupId: transferIn.academicGroup?.value,
    inAcademicGroupValue: transferIn.academicGroup?.label,
    inAcademicCareerId: transferIn.academicCareer?.value,
    inAcademicCareerValue: transferIn.academicCareer?.label,

    outAcademicCareerValue: transferOut.academicCareerValue,
    outAcademicCareerId: transferOut.academicCareerId ?? null,

    effectiveDate: new Date(transferIn.effectiveDate).toISOString(),
    reasonOfTransfer: transferIn.transferReason?.value,
    description: transferIn?.remarks,
    outBusinessArea: transferOut?.businessAreaDispVal,
    s3KeyList: (transferIn.supportingDoc || []).map((item) => item?.key),
    id: transferOut?.id,
    outBusinessAreaType: outBuType,
    inBusinessAreaType: inBuType
  };
};

const getFileObjectFormat = (list = []) => {
  return list.map((filePath) => ({ key: filePath }));
};

export const createTransferObjects = (params = {}, dropdown = {}) => {
  const {
    inCourseId = "",
    termId = "",
    termValue,
    inAcademicGroupId = "",
    inAcademicCareerId = "",
    effectiveDate = "",
    s3KeyList = [],

    // Transfer-out (current) student fields
    transferOutAppId,
    psid = "",
    studentName = "",

    outBusinessUnitId = "",
    outBusinessArea = "",
    outCourseId = "",
    outTermId = "",
    outAcademicGroupId = "",
    outAcademicGroupValue = "",
    outAcademicCareerId = "",
    outAcademicCareerValue,
    id,
    inAcademicCareerValue,
    inAcademicGroupValue,
    reasonOfTransfer,
    inBusinessUnitId,
    ...rest
  } = params;

  const transferDetails = {
    ...rest,
    businessArea: findByLabel(inBusinessUnitId, dropdown?.businessAres),
    courseId: {
      value: inCourseId,
      label: inCourseId,
    },
    term: {
      value: termId,
      label: termValue,
    },
    academicGroup: {
      value: inAcademicGroupId,
      label: inAcademicGroupValue,
    },
    academicCareer: {
      value: inAcademicCareerId,
      label: inAcademicCareerValue,
    },
    effectiveDate: effectiveDate,
    transferReason: findByLabel(reasonOfTransfer, transferReasonDropdown),
    supportingDoc: Array.isArray(s3KeyList)
      ? getFileObjectFormat(s3KeyList)
      : [],
  };
  debugger;

  const selectedStudent = {
    applicationId: transferOutAppId,
    psid: psid,
    studentName: studentName,
    businessArea: outBusinessUnitId,
    courseId: outCourseId,
    term: outTermId || termId,
    academicGroupDispValue: outAcademicGroupValue,
    academicGroup: outAcademicGroupId,
    academicCareerValue: outAcademicCareerValue,
    academicCareerId: outAcademicCareerId,
    businessAreaDispVal: outBusinessArea,
    isEditMode: true,
    transferRequestNo: id,
    id: id,
    termDispVal: termValue,
  };

  return { transferDetails, selectedStudent };
};
